(function() {
    'use strict';

    /** @constant */
    var CLASS_CARDS = 'summary-cards';


    angular.module( APP_ID )
        .component( 'postgradSummaryCards', {
            bindings: {
                content:    '<'
            },
            templateUrl:  'app/views/partials/content/postgrad-summary-cards.html',
            controller:   PostgradSummaryCardsController,
            controllerAs: 'vm',
            renderingOptions: {
                'atAGlance': {
                    inputs:    [
                        'content="::content.asset_contents"'
                    ],
                    parentClasses: [ CLASS_CARDS ]
                }
            }
        });


    /**
     * A dynamic block that lists all given qualification as postgraduate
     * summary cards.
     *
     * Important: In case any significant changes are made to this component,
     * please re-test according to the https://victoriauniversity.atlassian.net/wiki/spaces/WT/pages/168198145/Blackbox+testing+guide+for+Topics+Programmes#BlackboxtestingguideforTopics&Programmes-Postgraduate'summary'cards
     *
     *
     * @param {ng.IScope} $scope
     * @param {ng.ITimeoutService} $timeout
     * @param {SubpagesService} SubpagesService
     * @param {SelectablesService} SelectablesService
     * @param {LoggerFactory} LoggerFactory
     * @param {Utils} Utils
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function PostgradSummaryCardsController(
        $scope,
        $timeout,
        SubpagesService,
        SelectablesService,
        LoggerFactory,
        Utils,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @const */
        var POSTGRADS_SELECTABLE_ID     = 'postgradQuals',
        RESPONSE_ATTRIBUTE_UNENROLLABLE = 'unenrollable',

        _       = TEXTS.POSTGRAD.SUMMARY_CARD;


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'PostgradSummaryCardsController', false );





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        vm.$onInit = function() {
            overrideCTAButtonIfPostgradPage();
            initModel();
        };





        /* ===== PRIVATE FUNCTIONS ========================================== */


        /**
         * Makes the array of cards available at `vm.postgradQualsList`.
         */
        function initModel() {
            if ( SubpagesService.isPostgradAcademicSubpage() ) {
                initSingleAcademicPostgradCard();
            } else {
                initAllEnrollablePostgradCards();
            }
        }


        function postModelInit() {
            // Alias for the length check
            
            
            if (SubpagesService.isPostgradSubpage() && vm.postgradQualsList.length == 1){
                vm.isSingleOverviewCard = true;
            }
            else if (SubpagesService.isSpecialisation() && vm.postgradQualsList.length == 1){
                vm.isSingleOverviewCard = true;
            }
            else {
                vm.isSingleOverviewCard = false;
            }

            // Remove lines around the block if it's an overview card!
            if ( vm.isSingleOverviewCard ) {
                $timeout( function() {
                    angular.element( '.' + CLASS_CARDS ).addClass( 'no-lines' );
                }, 0 );
            }
        }


        /**
         * Render a single card only - either the qualification default or
         * the selected subject's one.
         */
        function initSingleAcademicPostgradCard() {
            SelectablesService.getSelectablesByIdPromise( POSTGRADS_SELECTABLE_ID ).then( function( selectables ) {
                var primaryQual = selectables.model.primaryItem;
                
                if ( primaryQual ) {
                    // Academic postgrad with the subject selected? => Render information about the selected subject
                    vm.postgradQualsList    = [ primaryQual.content ];
                    vm.showSubqualInfo      = true;
                } else {
                    // Academic postgrad with no subject selected? => Render information about master qualification
                    vm.postgradQualsList = [ { metadata: Utils.retrieveMetadataRecursively( $scope ) } ];
                }

                postModelInit();
            }).catch( function( err ) {
                logger.error( err );
            });
        }


        /**
         * Render all available sub-qualifications into which students can
         * enroll.
         */
        function initAllEnrollablePostgradCards() {
            vm.postgradQualsList = vm.content.qualifications.filter( function( singleQual ) {
                return !( singleQual.hasOwnProperty( 'metadata' ) && singleQual.metadata.hasOwnProperty( RESPONSE_ATTRIBUTE_UNENROLLABLE ) && singleQual.metadata[ RESPONSE_ATTRIBUTE_UNENROLLABLE ] === 'true');
            });

            postModelInit();
        }


        function overrideCTAButtonIfPostgradPage() {
            if ( SubpagesService.isPostgradSubpage() ) {
                vm.cardCtaButtonObject = {
                    stateId:    CONFIG.STATES.POSTGRADS.REQUIREMENTS,
                    label:      _.BUTTONS.VIEW_LABEL,
                    title:      _.BUTTONS.VIEW_TITLE
                };
            }
        }
    }


    PostgradSummaryCardsController.$inject  = [ '$scope', '$timeout', 'SubpagesService', 'SelectablesService', 'LoggerFactory', 'Utils', 'TEXTS', 'CONFIG' ];
})();
